import { createFileRoute } from "@tanstack/react-router";
import { PortalVipGate } from "@/components/portal/PortalVipGate";

export const Route = createFileRoute("/portal-vip/descartados")({
  component: () => <PortalVipGate mode="descartados" />,
});
